import * as yup from "yup";
import { CPFvalidator, hasValidSurname } from ".";

export const EMAIL_VALIDATION = yup
  .string()
  .email("Informe um endereço de email válido!")
  .required("E-mail é obrigatório!");

export const PASSWORD_VALIDATION = yup
  .string()
  .required("Uma senha é obrigatória!")
  .min(6, "Informe uma senha com mais de 6 caracteres!");

export const NAME_VALIDATION = yup
  .string()
  .required("Nome e sobrenome são obrigatórios!")
  .test(
    "has-surname",
    "Por favor, informe seu nome completo com sobrenome (mínimo 3 caracteres)",
    (value) => hasValidSurname(value)
  );

export const PHONE_VALIDATION = yup
  .string()
  .required("Telefone é obrigatório!")
  .test(
    "phone-format",
    "Telefone deve ter 11 dígitos (DDD + 9 dígitos)",
    (value) => {
      if (!value) return false;
      const numbers = value.replace(/\D/g, "");
      return numbers.length === 11;
    }
  );

export const CPF_VALIDATION = yup
  .string()
  .required("CPF é obrigatório!")
  .test("invalid-cpf", "CPF inválido!", (value) => CPFvalidator(value))
  .min(8, "Informe um CPF com mais de 8 caracteres!");

export const ADDRESS_VALIDATION = yup
  .string()
  .required("Endereço é obrigatório!");

export const TITLE_VALIDATION = yup.string().required("Título é obrigatório!");
export const DESCRIPTION_VALIDATION = yup.string().optional();
export const PLACE_VALIDATION = yup
  .string()
  .required("Um lugar, unidade ou responsável é obrigatório!");

export const MESSAGE_VALIDATION = yup
  .string()
  .required("Mensagem é obrigatória!")
  .min(10, "Informe uma mensagem com mais de 10 caracteres!");

export const CATEGORY_VALIDATION = yup
  .string()
  .required("Categoria é obrigatória!")
  .typeError("Categoria é obrigatória!");
